define('shared/util/checkout/directdebit',['shared/lib/RSVP'],
function (RSVP) {
    var generatedMandateId;
    var generatedMandateDate;
    var dateUsed;

    function ensureDateInitialized(){
        if(!dateUsed){
            dateUsed = new Date();
        }
    }

    function padForTwoDigits(s) {
        return (s < 10) ? '0' + s.toString() : s.toString();
    }

    return {

        getMandateId: function(){
            return RSVP.resolve().then(function(){
                ensureDateInitialized();
                if(!generatedMandateId){
                    generatedMandateId = dateUsed.getTime().toString();
                }

                return generatedMandateId;
            });
        },

        getRawMandateDate: function(){
            return RSVP.resolve().then(function(){
                ensureDateInitialized();
                return dateUsed;
            });
        },

        getMandateDate: function(){
            return RSVP.resolve().then(function(){
                ensureDateInitialized();
                if(!generatedMandateDate){
                    var d = dateUsed;
                    generatedMandateDate = d.getFullYear().toString() + padForTwoDigits(d.getMonth() + 1) + padForTwoDigits(d.getDate());
                }

                return generatedMandateDate;
            });
        },

        getLocalMandateDate: function(){
            return RSVP.resolve().then(function(){
                ensureDateInitialized();
                return dateUsed.toLocaleDateString();
            });
        },

        isOneOffOrder: function(order){
            return order
                && order.phase0
                && !order.phase0.is_recurring
                && order.phase0.repeat_times == 1
                && !order.phase1
                && !order.phase2;
        }
    };
});
